
import React from 'react';
import HeroBackground from './hero/HeroBackground';
import HeroContent from './hero/HeroContent';
import ScrollIndicator from './hero/ScrollIndicator';

const SellCarHero = () => {
  const scrollToProcess = () => {
    const processSection = document.getElementById('process-section');
    if (processSection) {
      processSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 overflow-hidden">
      <HeroBackground />

      <div className="relative z-10 container mx-auto px-4 py-12 md:py-20 flex items-center justify-center min-h-screen">
        <HeroContent scrollToProcess={scrollToProcess} />
      </div>

      <ScrollIndicator />
    </section>
  );
};

export default SellCarHero;
